import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {bbDangerousStringToDate, bbFindEntityWithinPortfolioOrSelf, bbScopeIcon} from "../../../util/bbHelpers";
import {CircularProgress, Dialog, DialogContent, DialogTitle, IconButton} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import {Button, Col, Row} from "reactstrap";
import {tagIdentityInScope, tagIdentityOutOfScope, tagVectorInScope, tagVectorOutOfScope} from "../../../actions";

const IdentityScopeToggle = ({identityId = null,})=>{

    const {loadingAddTag, loadingAddTagError, loadingUpdateTag, loadingUpdateTagError} = useSelector(({common})=> common);

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios, loadingPortfolios, loadingPortfoliosError, loadingCycles, loadingCyclesError, loadingCycleDetails, loadingCycleDetailsError, selfEntityId} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);


    const lastCycle = myEntity && myEntity.cycles && myEntity.settings && myEntity.settings.last_cycle_id ? myEntity.cycles[myEntity.settings.last_cycle_id] : null;

    const lastCycleDate = lastCycle && lastCycle.summary && lastCycle.summary.cycle_datetime ? bbDangerousStringToDate(lastCycle.summary.cycle_datetime) : null;

    const social = lastCycle
        && lastCycle.social
        && lastCycle.social

    const identities = social && social.identities;

    const identity = identities && identityId ? identities[identityId] : null;

    const identityTags = identity && identity.tags && Object.values(identity.tags).filter((tag)=> tag.is_active)

    const isOutOfScope = identityTags && Array.isArray(identityTags) && identityTags.length > 0;

    const outOfScopeTag = isOutOfScope
        ? identityTags
            .sort((a,b)=> b.added_datetime - a.added_datetime)
            .slice(0, 1)
            .shift()
        : null;

    // console.log("identity in the identity table", identityId, identity, identityTags, isOutOfScope,);
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();

    const handleClick = () => {
        if(isOutOfScope){
            // console.log("setting Vector in Scope with ", customerId, vectorId, outOfScopeTag)
            dispatch(tagIdentityInScope(customerIdToUse, identityId, outOfScopeTag))
            console.log("Identity set in scope.")
            setOpen(false);
        }
        if (!isOutOfScope){
            // console.log("setting Vector out of Scope with ", customerId, entityId, vectorId, testedVectorId)
            dispatch(tagIdentityOutOfScope(customerIdToUse, entityInView, identityId))
            console.log("Identity set out of scope")
            setOpen(false);
        }

    }



    return(
        <div>
            <IconButton
                className={"m-0 p-0 text-center align-self-center d-inline"}
                onClick={()=> setOpen(true)}>
                {loadingAddTag[identityId] || (identityTags && identityTags[0] && loadingUpdateTag[identityTags[0].id])
                    ? <CircularProgress size={16}/>
                    : bbScopeIcon(isOutOfScope)
                }

            </IconButton>

            <Dialog open={open}
                    fullScreen={false}
                    maxWidth={"sm"}
                    className={"text-center m-1 p-1 animated fadeIn animation-duration-7"}>
                <DialogTitle
                    onClick={()=> setOpen(false)}>
                    <h1>Confirm Change
                        <IconButton
                            onClick={()=>setOpen(false)}
                            style={{float: "right", margin: "0", padding: "0"}}>
                            <CloseIcon/>
                        </IconButton>
                    </h1>
                </DialogTitle>
                <DialogContent>
                    <Row>
                        Are you sure you want to {isOutOfScope
                        ? "place element back in scope?"
                        : "place element out of scope?"}
                    </Row>
                    <br/>
                    <Row className={"text-center align-self-center"}>
                        <Col className={"align-content-center"}>
                            <Button onClick={handleClick}
                                    variant={"contained"}
                                    color={"primary"}> CONFIRM</Button>
                            <Button onClick={()=> setOpen(false)}
                                    variant={"contained"}
                                    color="primary"> CANCEL </Button>
                        </Col>
                    </Row>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default IdentityScopeToggle;